// extracted by mini-css-extract-plugin
module.exports = {"slide":"One_slide__1IW1E","backgroundText":"One_backgroundText__tvY9m","wrapper":"One_wrapper__24uU4"};